import styled from 'styled-components'
import spinnerImg from '../../images/main/spinner.svg'

export default styled.div`
  background: url(${spinnerImg}) center center no-repeat;
  background-size: 100%;
  display: inline-block;
  width: 16px;
  height: 16px;
  cursor: default;
  top: 2px;
  position: relative;
  margin-left: 5px;
`
